(function waitForjQuery(callback) {
  if (typeof window.jQuery !== 'undefined') {
    callback(window.jQuery);
  } else {
    setTimeout(function() { waitForjQuery(callback); }, 50);
  }
})(function($) {
  var paramName = "rb_filter_ptag_9da5166596572e8efeb738b467730225";
  var params = new URLSearchParams(window.location.search);
  if (!params.has(paramName)) return;

  function getLabelOrNullIfLoading() {
    var make = $('select.mk option:selected').text().trim();
    var model = $('select.md option:selected').text().trim();
    if (make === "Loading" || model === "Loading") return null;
    if (make === "Brand" || model === "Model") return null;
    if (make && model) return (make + ' ' + model).trim();
    return null;
  }

  function getParamLabel() {
    return params.get(paramName)
      .replace(/-/g, ' ')
      .replace(/\s*\d{4}$/, '')
      .trim();
  }

  function updateResultsDiv() {
    var $div = $('.snize-main-panel-collection-results-found');
    if ($div.length) {
      var label = getLabelOrNullIfLoading();
      if (!label) {
        label = getParamLabel();
      }
      $div.each(function() {
        var html = $(this).html();
        html = html.replace(/("|&quot;)?All("|&quot;)?/g, '"' + label + '"');
        $(this).html(html);
      });
    }
  }

  function observeResultsDiv() {
    var target = document.querySelector('.snize-main-panel-collection-results-found');
    if (!target) {
      setTimeout(observeResultsDiv, 100);
      return;
    }

    // Initial update
    updateResultsDiv();

    var observer = new MutationObserver(function() {
      updateResultsDiv();
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  observeResultsDiv();
});
